import CloseIcon from '@mui/icons-material/CloseOutlined';
import type {ReactNode} from 'react';

import css from './DialogClose.module.css';

interface DialogCloseProps {
	onClose: () => void;
	/** Закрывать нельзя, пока идёт отправка: на полпути окно закроется молча. */
	disabled?: boolean;
	icon?: ReactNode;
	className?: string;
}

/**
 * Крестик в правом верхнем углу модалки.
 *
 * Отдельный компонент, а не разметка в каждом диалоге: положение, размер области
 * нажатия и подпись для читалки экрана обязаны совпадать во всех окнах — иначе
 * крестик оказывается то на восьми пикселях от края, то на двадцати, и это видно.
 *
 * Заменяет кнопку «Отмена» там, где так рисует макет. Вместе они избыточны: два
 * способа закрыть окно рядом друг с другом заставляют выбирать между ними,
 * хотя разницы нет.
 */
export function DialogClose({onClose, disabled, icon, className}: DialogCloseProps) {
	return (
		<button
			type="button"
			className={`${css.close} ${className ?? ''}`}
			aria-label="Закрыть"
			disabled={disabled}
			onClick={onClose}
		>
			{icon ?? <CloseIcon fontSize="inherit" />}
		</button>
	);
}
